import React from "react";
import { Helmet } from "react-helmet";
import "../styles/about.css";
import AboutUsCard from "./AboutUsCard";

const About = () => {
  // SEO metadata
  const pageTitle = "Classic Motors KE - Trusted Car Dealer in Mombasa";
  const pageDescription =
    "Classic Motors KE is a leading car dealer in Mombasa specializing in new, foreign used & locally used vehicles. 10+ years experience with 100% delivery record. Call 0707308556";
  const canonicalUrl = "https://www.classicmotorske.com/about";
  const keywords =
    "car dealer Mombasa, about Classic Motors KE, used cars Kenya, vehicle import Kenya, trusted car dealer";

  // Generate LocalBusiness schema
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "AutoDealer",
    name: "Classic Motors KE",
    description:
      "Leading car dealer in Mombasa Kenya specializing in new, foreign used, and locally used vehicles with 100% delivery record",
    url: "https://www.classicmotorske.com",
    logo: "https://www.classicmotorske.com/logo.jpg",
    telephone: "+254707308556",
    address: {
      "@type": "PostalAddress",
      streetAddress: "",
      addressLocality: "Mombasa",
      addressRegion: "Mombasa",
      postalCode: "",
      addressCountry: "KE",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "-4.0435",
      longitude: "39.6682",
    },
    openingHours: "Mo-Fr 08:00-17:00, Sa 08:00-13:00",
    priceRange: "$$$",
    sameAs: [
      "https://www.facebook.com/classicmotorske",
      "https://www.instagram.com/classicmotorske",
    ],
  };

  return (
    <main
      className="about-page"
      style={{ marginTop: "60px" }}
      itemScope
      itemType="https://schema.org/AboutPage"
    >
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
      </Helmet>
      <AboutUsCard />
      <section id="about" className="about-wrapper">
        {/* Testimonials Section */}
        <div className="about-testimonials">
          <div className="container">
            <h2 className="section-title">What Our Customers Say</h2>
            <p className="section-subtitle">
              Hear from satisfied clients across Mombasa and Kenya
            </p>
            <div className="testimonials-grid">
              <div
                className="testimonial-card"
                itemScope
                itemType="https://schema.org/Review"
              >
                <div className="testimonial-content">
                  <p itemProp="reviewBody">
                    "Classic Motors KE helped me import my dream car from Japan.
                    Their process was transparent and they handled all the
                    paperwork. Highly recommend for anyone in Mombasa looking
                    for quality vehicles!"
                  </p>
                </div>
                <div className="testimonial-author">
                  <span itemProp="author">James M.</span>
                  <span itemProp="locationCreated">Mombasa</span>
                </div>
              </div>
              {/* Add more testimonials with schema markup */}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
